import axios from "axios";
import config from "./config";

class Request {
    constructor(_apiKey) {
        this._headers = {
            headers: { Authorization: `Api-Key ${_apiKey}`, "Content-Type": "application/json" }
        };
    }

    async fetch({ method, endpoint, params }) {
        try {
            let results = null;
            switch (method) {
                case "GET":
                case "DELETE":
                    let paramsStr = "";
                    if (Array.isArray(params)) paramsStr = params.join("/");
                    if (params) paramsStr = `/${paramsStr}`;
                    
                    results = await axios[method.toLowerCase()](`${config.API_URL}/${endpoint}${paramsStr}`, this._headers);
                    break;
                case "POST":
                case "PUT":
                    results = await axios[method.toLowerCase()](`${config.API_URL}/${endpoint}`, params, this._headers);
                    break;

                default:
                    break;
            }
            return results ? results.data : null;
        } catch (_err) {
            if(_err.response.data && _err.response.data.message)
                throw new Error(JSON.stringify(_err.response.data.message));
            else
                throw Error(_err.response.statusText);
        }
    }
}

export default Request;
